export default "__VITE_ASSET__BABu3UDC__"